import React from 'react'

import cn from '../../libs/class-names'

import placeholder from '../../assets/icons/placeholder.svg'

export type IconSource = {
  id: string
}
export interface Props {
  classNames?: string[]
  title?: string
  source?: IconSource
  block?: boolean
}

const Icon = ({block = false, classNames, title, source = placeholder}: Props) => (
  <svg className={cn('Icon', {block}, classNames)} role={title ? 'img' : 'presentation'}>
    <use xlinkHref={`#${source.id}`} />
    {title && <title>{title}</title>}
  </svg>
)

export default Icon
